import React, {Component} from 'react';

import { Polyline } from 'google-maps-react';


const noOutageColor = '#0033cc'
const outageColor = '#ff0000';


class LightningStrikeAffectedSections extends Component {

    componentDidMount(){
        this.loadLightningStrikeAffectedAreas();
    }

    shouldComponentUpdate(nextProps){
        if(this.props.ohlLightningAffectedAreasList.length !== nextProps.ohlLightningAffectedAreasList.length
            || this.props.showOutageLayer !== nextProps.showOutageLayer
            || this.props.showAffectedOhlSections !== nextProps.showAffectedOhlSections){
            return true
        }
        else{
            return false;
        }
    }

    componentDidUpdate(){
        this.loadLightningStrikeAffectedAreas();
    }
    

    loadLightningStrikeAffectedAreas = () => {
        let affectedOhlSectionsList = [];

        if(this.props.showOutageLayer && this.props.showAffectedOhlSections){
            this.props.ohlLightningAffectedAreasList.forEach((section, index) => {
                const affectedSection = 
                    <Polyline
                        key={index}
                        path={section.poles}
                        name={'thunderStrike'}
                        strokeOpacity={0.3}
                        strokeColor={section.isOutage ? outageColor : noOutageColor}
                        strokeWeight={14}
                    />
                affectedOhlSectionsList.push(affectedSection);
            });
        }

        this.props.sendChildElementDataToState(this.props.stateElementName, affectedOhlSectionsList);    
    }

    render(){
        return null;
    }
}

export default LightningStrikeAffectedSections;